/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IHospital } from 'app/shared/model/hospital.model';
import { IPaymentScheme } from 'app/shared/model/payment-scheme.model';
import { IBed } from 'app/shared/model/bed.model';
import { IRoom } from 'app/shared/model/room.model';
import { ChargeType } from 'app/shared/model/enumerations/charge-type.model';
import { InwardChargeType } from 'app/shared/model/enumerations/inward-charge-type.model';

export interface IWardCharges {
  id?: string;
  name?: string | null;
  description?: string | null;
  relatedTo?: string | null;
  charge?: number | null;
  chargeType?: keyof typeof ChargeType | null;
  inwardChargeType?: keyof typeof InwardChargeType | null;
  active?: boolean | null;
  microSec?: number | null;
  timestampentry?: number | null;
  lastupdated?: number | null;
  cursor?: number;
  tax?: string | null;
  multiplierApplied?: boolean;
  startDate?: number;
  endDate?: number | null;
  suspended?: boolean;
  draft?: boolean;
  hospital?: IHospital;
  scheme?: IPaymentScheme | null;
  bed?: IBed | null;
  room?: IRoom | null;
}

export const defaultValue: Readonly<IWardCharges> = {
  active: false,
  multiplierApplied: false,
  suspended: false,
  draft: false,
};
